import 'es6-promise/auto';

import { Product, METAFIELD_NAMESPACE } from "./product";

export class Loader {
    constructor(api) {
        this.api = api;
        this.productCache = {};
    }

    productFieldSpec(options) {
        const fieldSpec = {
            ajax: { },
            basic: { },
            collections: { first: 10 },
            variants: { metafields: { first: 10 } },
            metafields: { first: 10 }
        };

        const { imageSpec } = options;
        if (imageSpec) {
            fieldSpec.images = imageSpec;
            fieldSpec.variants.image = imageSpec;
        }

        return Object.assign({}, options, fieldSpec);
    }

    fetchProduct(handle, options) {
        const fetchOptions = this.productFieldSpec(options);
        return this.api
            .productByHandle(handle, fetchOptions)
            .then(({ ajax, storefront }) => {
                const product = new Product(ajax, storefront);
                this.productCache[handle] = product;
                return product;
            });
    }

    getProduct(handle, options = {}) {
        const staticData = this.getStaticProductData(handle);
        // if (staticData !== null)
        //     return Promise.resolve(staticData);

        const data = this.productCache[handle];
        // if (data !== undefined)
        //     return Promise.resolve(data);

        return this.fetchProduct(handle, options);
    }

    /* Retrieves statically-generated product data as a dual-API product object. */
    getStaticProductData(handle) {
        const store = window.staticProductData;
        if (!store)
            return null;

        const data = store[handle];
        if (!data)
            return null;

        return new Product(data, null);
    }
}
